import CCColors from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

const borderColor = '#E5E1DA';

export const csocSetupStyles = StyleSheet.create({
  page: {
    minHeight: 720,
    padding: 18,
    backgroundColor: '#FAF7EF',
  },
  pageMobile: {
    padding: 12,
  },
  content: {
    width: '100%',
    maxWidth: 1480,
    alignSelf: 'center',
    paddingBottom: 40,
  },
  paymentStrip: {
    minHeight: 46,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderWidth: 1,
    borderColor: '#B9DFCF',
    borderRadius: 8,
    backgroundColor: '#DFF3E9',
  },
  paymentStripMobile: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: 8,
  },
  paymentStripMessage: {
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
  },
  paymentStripIcon: {
    width: 24,
    height: 24,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    backgroundColor: '#25745F',
  },
  paymentStripTitle: {
    color: '#175C49',
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
  },
  paymentStripText: {
    color: '#175C49',
    fontSize: 13,
    lineHeight: 19,
  },
  paymentStripMeta: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
  },
  paymentStripMetaText: {
    color: '#4B7568',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '600',
  },
  welcome: {
    position: 'relative',
    minHeight: 170,
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 14,
    paddingHorizontal: 24,
    paddingVertical: 20,
    paddingRight: 174,
    borderRadius: 8,
    backgroundColor: '#4D4038',
  },
  welcomeMobile: {
    minHeight: 0,
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: 20,
  },
  welcomeCopy: {
    flex: 1,
    minWidth: 0,
    maxWidth: 680,
  },
  welcomeEyebrow: {
    color: '#5EB1A7',
    fontSize: 11,
    lineHeight: 15,
    fontWeight: '700',
  },
  welcomeTitle: {
    color: CCColors.White,
    fontSize: 28,
    lineHeight: 36,
    fontWeight: '700',
    marginTop: 5,
  },
  welcomeBody: {
    maxWidth: 650,
    color: '#E5DCD5',
    fontSize: 14,
    lineHeight: 21,
    marginTop: 5,
  },
  contactSupportButton: {
    alignSelf: 'flex-start',
    marginTop: 12,
    borderRadius: 8,
    borderColor: 'rgba(255, 255, 255, 0.55)',
    backgroundColor: 'transparent',
  },
  contactSupportButtonContent: {
    minHeight: 36,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 13,
    paddingVertical: 8,
  },
  welcomeProfile: {
    width: 360,
    flexShrink: 0,
    marginLeft: 30,
    paddingLeft: 30,
    borderLeftWidth: 1,
    borderLeftColor: 'rgba(255, 255, 255, 0.2)',
  },
  welcomeProfileMobile: {
    width: '100%',
    marginLeft: 0,
    marginTop: 18,
    paddingLeft: 0,
    paddingTop: 16,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255, 255, 255, 0.2)',
  },
  welcomeProfileHeading: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  welcomeProfileTitle: {
    flex: 1,
    color: CCColors.White,
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
  },
  welcomeProfilePercentage: {
    flexShrink: 0,
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
  },
  welcomeProgressTrack: {
    width: '100%',
    height: 8,
    overflow: 'hidden',
    marginTop: 9,
    borderRadius: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  welcomeProgressFill: {
    height: '100%',
    borderRadius: 4,
  },
  welcomeProfileFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 9,
  },
  welcomeProfileMeta: {
    flex: 1,
    color: '#D9CEC7',
    fontSize: 11,
    lineHeight: 16,
  },
  continueProfileText: {
    color: '#F6D35C',
    fontSize: 11,
    lineHeight: 16,
    fontWeight: '700',
  },
  welcomeCaissa: {
    position: 'absolute',
    right: 18,
    bottom: -1,
    width: 142,
    height: 142,
  },
  setupGrid: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 16,
    marginTop: 16,
  },
  setupGridMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  card: {
    padding: 22,
    borderWidth: 1,
    borderColor,
    borderRadius: 8,
    backgroundColor: CCColors.White,
    shadowColor: '#302A27',
    shadowOffset: {width: 0, height: 3},
    shadowOpacity: 0.045,
    shadowRadius: 10,
  },
  cardCompact: {
    width: '100%',
    padding: 16,
  },
  sectionHeading: {
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 11,
  },
  sectionIcon: {
    width: 36,
    height: 36,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 18,
    backgroundColor: '#E7F4F1',
  },
  sectionHeadingCopy: {
    flex: 1,
    minWidth: 0,
  },
  sectionTitle: {
    color: '#302A27',
    fontSize: 20,
    lineHeight: 27,
    fontWeight: '700',
  },
  sectionSubtitle: {
    color: '#79736F',
    fontSize: 12,
    lineHeight: 18,
    marginTop: 1,
  },
  learningCard: {
    flex: 7,
    minWidth: 0,
  },
  learningCardCompact: {
    width: '100%',
  },
  learningHeadingRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
  },
  milestoneCard: {
    flex: 3,
    minWidth: 270,
  },
  milestoneCardCompact: {
    width: '100%',
    minWidth: 0,
  },
  milestoneList: {
    position: 'relative',
    marginTop: 14,
  },
  milestoneTrack: {
    position: 'absolute',
    top: 20,
    bottom: 20,
    left: 19,
    width: 2,
    backgroundColor: borderColor,
  },
  milestoneRow: {
    minHeight: 52,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  milestoneDot: {
    width: 40,
    height: 40,
    zIndex: 1,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor,
    borderRadius: 20,
    backgroundColor: CCColors.White,
  },
  milestoneDotDone: {
    borderColor: '#5AABA2',
    backgroundColor: '#5AABA2',
  },
  milestoneDotCurrent: {
    borderColor: '#D2AF3E',
    backgroundColor: '#FFF4C9',
  },
  milestoneCopy: {
    flex: 1,
    minWidth: 0,
  },
  milestoneTitle: {
    color: '#302A27',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '700',
  },
  milestoneStatus: {
    color: '#79736F',
    fontSize: 11,
    lineHeight: 16,
    marginTop: 2,
  },
  milestoneStatusDone: {
    color: '#55ADA4',
    fontWeight: '700',
  },
  learningColumns: {
    flexDirection: 'row',
    marginTop: 18,
    borderTopWidth: 1,
    borderTopColor: borderColor,
  },
  learningColumnsMobile: {
    flexDirection: 'column',
  },
  firstClassPanel: {
    flex: 0.85,
    minWidth: 300,
    paddingTop: 20,
    paddingRight: 24,
  },
  firstClassPanelMobile: {
    minWidth: 0,
    paddingRight: 0,
  },
  classState: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 15,
  },
  classDateTile: {
    width: 72,
    height: 82,
    flexShrink: 0,
    overflow: 'hidden',
    alignItems: 'center',
    borderWidth: 1,
    borderColor,
    borderRadius: 8,
    backgroundColor: CCColors.White,
  },
  classDateTileHeader: {
    width: '100%',
    minHeight: 35,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
    backgroundColor: '#DFF3E9',
  },
  classDateTileHeaderText: {
    color: '#25745F',
    fontSize: 9,
    lineHeight: 12,
    fontWeight: '700',
    textAlign: 'center',
  },
  classDateTileDay: {
    color: '#55ADA4',
    fontSize: 23,
    lineHeight: 29,
    fontWeight: '700',
    marginTop: 4,
  },
  classDateTileMonth: {
    color: '#79736F',
    fontSize: 10,
    lineHeight: 13,
    fontWeight: '600',
  },
  classStateCopy: {
    flex: 1,
    minWidth: 0,
  },
  classStateLabel: {
    color: '#55ADA4',
    fontSize: 10,
    lineHeight: 14,
    fontWeight: '700',
  },
  classStateTitle: {
    color: '#302A27',
    fontSize: 18,
    lineHeight: 24,
    fontWeight: '700',
    marginTop: 8,
  },
  classStateDescription: {
    color: '#79736F',
    fontSize: 12,
    lineHeight: 18,
    marginTop: 4,
  },
  classMeta: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 14,
  },
  classMetaItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  classMetaText: {
    color: '#77706B',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '600',
  },
  walkthroughPrompt: {
    marginTop: 18,
    padding: 14,
    borderRadius: 8,
    backgroundColor: '#E7F4F1',
  },
  walkthroughTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 11,
  },
  walkthroughIcon: {
    width: 42,
    height: 42,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 21,
    backgroundColor: CCColors.White,
  },
  walkthroughCopy: {
    flex: 1,
    minWidth: 0,
  },
  walkthroughTitle: {
    color: '#302A27',
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '700',
  },
  walkthroughDescription: {
    color: '#716B67',
    fontSize: 11,
    lineHeight: 16,
    marginTop: 2,
  },
  walkthroughButton: {
    width: '100%',
    marginTop: 12,
    borderRadius: 8,
    backgroundColor: '#F6D35C',
  },
  walkthroughButtonContent: {
    minHeight: 42,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
    paddingVertical: 9,
  },
  joinButton: {
    width: '100%',
    marginTop: 18,
    borderRadius: 8,
    backgroundColor: '#F6D35C',
  },
  joinButtonContent: {
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  joinRestrictionModal: {
    width: '90%',
    maxWidth: 420,
  },
  curriculumPanel: {
    flex: 1.15,
    minWidth: 0,
    paddingTop: 20,
    paddingLeft: 24,
    borderLeftWidth: 1,
    borderLeftColor: borderColor,
  },
  curriculumPanelMobile: {
    marginTop: 18,
    paddingLeft: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderTopColor: borderColor,
  },
  curriculumHeader: {
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  curriculumHeaderMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 3,
  },
  curriculumTitle: {
    flex: 1,
    color: '#302A27',
    fontSize: 18,
    lineHeight: 24,
    fontWeight: '700',
  },
  curriculumCount: {
    flexShrink: 1,
    color: '#79736F',
    fontSize: 11,
    lineHeight: 16,
    textAlign: 'right',
  },
  curriculumList: {
    maxHeight: 256,
    marginTop: 8,
  },
  curriculumListContent: {
    paddingBottom: 2,
  },
  curriculumRow: {
    minHeight: 64,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: borderColor,
  },
  curriculumSessionBadge: {
    width: 34,
    height: 34,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 17,
    backgroundColor: '#E7F4F1',
  },
  curriculumSessionNumber: {
    color: '#4D9F96',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '700',
  },
  curriculumTopicCopy: {
    flex: 1,
    minWidth: 0,
    marginLeft: 11,
  },
  curriculumSessionLabel: {
    color: '#918C88',
    fontSize: 10,
    lineHeight: 14,
  },
  curriculumTopic: {
    color: '#302A27',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '700',
    marginTop: 1,
  },
  curriculumEmpty: {
    minHeight: 180,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 18,
  },
  curriculumEmptyText: {
    color: '#8D8884',
    fontSize: 12,
    lineHeight: 18,
    textAlign: 'center',
    marginTop: 9,
  },
  enrollmentCard: {
    marginTop: 16,
  },
  enrollmentHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
  },
  paidPill: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 8,
    backgroundColor: '#DFF3E9',
  },
  paidPillText: {
    color: '#25745F',
    fontSize: 11,
    lineHeight: 15,
    fontWeight: '700',
  },
  enrollmentColumns: {
    flexDirection: 'row',
    marginTop: 18,
    borderTopWidth: 1,
    borderTopColor: borderColor,
  },
  enrollmentColumnsMobile: {
    flexDirection: 'column',
  },
  enrollmentColumn: {
    minWidth: 0,
    paddingTop: 18,
  },
  enrollmentColumnMobile: {
    width: '100%',
    paddingRight: 0,
  },
  paymentColumn: {
    flex: 0.85,
    paddingRight: 28,
  },
  subscriptionColumn: {
    flex: 1.15,
    paddingLeft: 28,
    borderLeftWidth: 1,
    borderLeftColor: borderColor,
  },
  subscriptionColumnMobile: {
    marginTop: 18,
    paddingLeft: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderTopColor: borderColor,
  },
  enrollmentColumnTitle: {
    color: '#302A27',
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '700',
  },
  enrollmentColumnHeader: {
    minHeight: 34,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 2,
  },
  subscriptionKnowMore: {
    flexShrink: 0,
    borderColor: '#D8D2CB',
    borderRadius: 6,
    backgroundColor: CCColors.White,
  },
  subscriptionKnowMoreContent: {
    minHeight: 30,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 11,
    paddingVertical: 5,
  },
  subscriptionKnowMoreText: {
    color: '#4D4038',
    fontSize: 11,
    lineHeight: 15,
    fontWeight: '700',
  },
  detailGrid: {
    flexDirection: 'row',
    gap: 24,
  },
  detailGridMobile: {
    flexDirection: 'column',
    gap: 0,
  },
  detailGridColumn: {
    flex: 1,
    minWidth: 0,
  },
  detailRow: {
    minHeight: 50,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: borderColor,
  },
  detailRowLast: {
    borderBottomWidth: 0,
  },
  detailLabel: {
    flexShrink: 0,
    color: '#928D89',
    fontSize: 12,
    lineHeight: 17,
  },
  detailValue: {
    flexShrink: 1,
    color: '#302A27',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '700',
    textAlign: 'right',
  },
  pendingValue: {
    color: '#D47B49',
    fontStyle: 'italic',
  },
  invoiceAction: {
    flexShrink: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 6,
  },
  invoiceActionText: {
    color: '#4D4038',
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '700',
    textAlign: 'right',
  },
  practiceHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginTop: 24,
    marginBottom: 12,
  },
  practiceHeaderMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 3,
  },
  practiceHeaderTitle: {
    color: '#302A27',
    fontSize: 17,
    lineHeight: 23,
    fontWeight: '700',
  },
  practiceHeaderSubtitle: {
    flexShrink: 1,
    color: '#79736F',
    fontSize: 11,
    lineHeight: 16,
    textAlign: 'right',
  },
  practiceHeaderSubtitleMobile: {
    textAlign: 'left',
  },
  practiceGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  practiceCard: {
    width: '23.5%',
    minHeight: 100,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    padding: 14,
    borderWidth: 1,
    borderColor,
    borderRadius: 8,
    backgroundColor: CCColors.White,
    shadowColor: '#302A27',
    shadowOffset: {width: 0, height: 3},
    shadowOpacity: 0.045,
    shadowRadius: 8,
  },
  practiceCardMobile: {
    width: '100%',
    minHeight: 92,
  },
  practiceVisual: {
    width: 58,
    height: 58,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
  },
  practiceImage: {
    width: 50,
    height: 50,
  },
  practiceCopy: {
    flex: 1,
    minWidth: 0,
  },
  practiceTitle: {
    color: '#302A27',
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '700',
  },
  practiceSubtitle: {
    color: '#918C88',
    fontSize: 10,
    lineHeight: 15,
    marginTop: 3,
  },
  modalBackdrop: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 18,
    backgroundColor: 'rgba(38, 35, 34, 0.54)',
  },
  supportModal: {
    width: '100%',
    maxWidth: 520,
    padding: 22,
    borderRadius: 8,
    backgroundColor: CCColors.White,
    shadowColor: '#262322',
    shadowOffset: {width: 0, height: 10},
    shadowOpacity: 0.18,
    shadowRadius: 24,
  },
  supportModalHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 10,
  },
  supportModalHeaderCopy: {
    flex: 1,
    minWidth: 0,
  },
  supportModalTitle: {
    color: '#302A27',
    fontSize: 20,
    lineHeight: 27,
    fontWeight: '700',
  },
  supportModalSubtitle: {
    color: '#8D8884',
    fontSize: 13,
    lineHeight: 19,
    marginTop: 3,
  },
  modalCloseButton: {
    width: 34,
    height: 34,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 17,
    backgroundColor: '#F4F1EC',
  },
  supportContact: {
    minHeight: 64,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: borderColor,
  },
  supportContactIcon: {
    width: 34,
    height: 34,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 17,
    backgroundColor: '#E7F4F1',
  },
  supportContactCopy: {
    flex: 1,
    minWidth: 0,
    marginHorizontal: 11,
  },
  supportContactLabel: {
    color: '#8D8884',
    fontSize: 11,
    lineHeight: 15,
  },
  supportContactValue: {
    color: '#302A27',
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '700',
    marginTop: 2,
  },
  supportModalActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 18,
  },
  modalDoneButton: {
    borderRadius: 8,
    borderColor,
    backgroundColor: CCColors.White,
  },
  modalTicketButton: {
    borderRadius: 8,
    backgroundColor: '#F6D35C',
  },
  modalButtonContent: {
    minHeight: 42,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 17,
    paddingVertical: 9,
  },
});
